export const copyPhone = async (phone) => {
    if (!navigator.clipboard?.writeText) {
        return false;
    }

    try {
        await navigator.clipboard.writeText(phone);
        window.dispatchEvent(new CustomEvent('phone-copied'));
        return true;
    } catch {
        return false;
    }
};
